import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useCommonStyles } from '../../../common/hooks';

interface ConfirmReviewAndSubmitModalProps {
  isModalOpen: boolean;
  onDismissModal: () => void;
  onSubmitModal: () => void;
}

const ConfirmReviewAndSubmitModalImpl: React.FC<ConfirmReviewAndSubmitModalProps> = (props) => {
  const {
    isModalOpen,
    onDismissModal,
    onSubmitModal,
  } = props;

  const commonStyles = useCommonStyles();

  const handleClickBackButton = (): void => {
    onDismissModal();
  };

  const onSubmitButtonClicked = (): void => {
    onDismissModal();
    onSubmitModal();
  };

  return (
    <Dialog
      open={isModalOpen}
      onOpenChange={(_, data) => {
        if (!data.open) onDismissModal();
      }}
    >
      <DialogSurface
        className={commonStyles.modalSurface}
      >
        <DialogBody
          className={commonStyles.modalBody}
        >
          <DialogTitle>
            Confirm submission
          </DialogTitle>

          <DialogContent>
            Click Submit to finalize your nomination. Please make sure you have reviewed for any typos or grammatical errors before finalizing. To cancel and return to editing, click Back.
          </DialogContent>

          <DialogActions>
            <Button
              appearance='secondary'
              onClick={handleClickBackButton}
            >
              Back
            </Button>
            <Button
              appearance='primary'
              onClick={() => onSubmitButtonClicked()}
            >
              Submit
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

export const ConfirmReviewAndSubmitModal = observer(ConfirmReviewAndSubmitModalImpl);
